import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

const getContactsApi = async (): Promise<any[]> => {
  const response = await httpClient.get('api/contact/get', {});
  return response.data.data || response.data || [];
};

const createContactApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/contact/create', payload);
  return response.data;
};

const updateContactApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/contact/update', payload);
  return response.data;
};

export const useContacts = () => {
  return useQuery({
    queryKey: ['contacts'],
    queryFn: getContactsApi,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useCreateContact = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createContactApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contacts'] });
      queryClient.invalidateQueries({ queryKey: ['location-details'] });
    },
  });
};

export const useUpdateContact = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateContactApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contacts'] });
      queryClient.invalidateQueries({ queryKey: ['location-details'] });
    },
  });
};
